var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9999C31.0455 39.9999 39.9998 31.0456 39.9998 19.9999C39.9998 8.95418 31.0455 -0.00012207 19.9998 -0.00012207C8.95412 -0.00012207 -0.000183105 8.95418 -0.000183105 19.9999C-0.000183105 31.0456 8.95412 39.9999 19.9998 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1305 20H40C40 18.1949 39.7594 16.4461 39.311 14.7826H19.1305V20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1305 9.5652H37.0645C35.8402 7.56739 34.2748 5.80153 32.4497 4.34778H19.1305V9.5652Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 40C24.7069 40 29.0332 38.3732 32.4496 35.6522H7.55026C10.9667 38.3732 15.293 40 19.9999 40Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93545 30.4347H37.0645C38.0474 28.8309 38.8097 27.0778 39.311 25.2173H0.688965C1.19029 27.0778 1.95256 28.8309 2.93545 30.4347V30.4347Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26419 3.12316H11.0868L9.39146 4.3548L10.039 6.34769L8.3438 5.11605L6.64857 6.34769L7.20794 4.62605C5.71529 5.86941 4.407 7.32613 3.32888 8.94925H3.91286L2.83372 9.73324C2.6656 10.0137 2.50435 10.2986 2.34982 10.5878L2.86513 12.1738L1.90372 11.4753C1.66474 11.9816 1.44615 12.4993 1.24966 13.0278L1.81739 14.7753H3.91286L2.21755 16.007L2.86513 17.9999L1.1699 16.7682L0.154426 17.506C0.0527856 18.3231 -0.000183105 19.1553 -0.000183105 19.9999H19.9998C19.9998 8.95425 19.9998 7.65207 19.9998 -0.00012207C16.0489 -0.00012207 12.3658 1.14597 9.26419 3.12316V3.12316ZM10.039 17.9999L8.3438 16.7682L6.64857 17.9999L7.29614 16.007L5.60083 14.7753H7.6963L8.3438 12.7825L8.9913 14.7753H11.0868L9.39146 16.007L10.039 17.9999ZM9.39146 10.1809L10.039 12.1738L8.3438 10.9421L6.64857 12.1738L7.29614 10.1809L5.60083 8.94925H7.6963L8.3438 6.95636L8.9913 8.94925H11.0868L9.39146 10.1809ZM17.2129 17.9999L15.5177 16.7682L13.8225 17.9999L14.4701 16.007L12.7747 14.7753H14.8702L15.5177 12.7825L16.1652 14.7753H18.2607L16.5654 16.007L17.2129 17.9999ZM16.5654 10.1809L17.2129 12.1738L15.5177 10.9421L13.8225 12.1738L14.4701 10.1809L12.7747 8.94925H14.8702L15.5177 6.95636L16.1652 8.94925H18.2607L16.5654 10.1809ZM16.5654 4.3548L17.2129 6.34769L15.5177 5.11605L13.8225 6.34769L14.4701 4.3548L12.7747 3.12316H14.8702L15.5177 1.13027L16.1652 3.12316H18.2607L16.5654 4.3548Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStates);
export default __webpack_public_path__ + "static/media/united_states.e10fa0e438a3b982b3d426ddf1d4c730.svg";
export { ForwardRef as ReactComponent };